import { render, staticRenderFns } from "./UnauthenticatedUserFollowProjectForm.vue?vue&type=template&id=36c2774a"
import script from "./UnauthenticatedUserFollowProjectForm.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedUserFollowProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports